import {
  ReferralSubjectCodeResponse,
  ValidateCodeResponse,
} from '#client/resources/index'
import { HttpClient } from '#client/http/index'

export const findOrCreateSubjectCode = async ({
  httpClient,
}: {
  httpClient: HttpClient
}) => {
  const { data } = await httpClient.get<ReferralSubjectCodeResponse>(
    '/user/referrals/subjectCode',
  )
  return data
}

export const validateCode = async (
  {
    httpClient,
  }: {
    httpClient: HttpClient
  },
  code: string,
) => {
  const { data } = await httpClient.get<ValidateCodeResponse>(
    `/user/referrals/subjectCode/validate/${code}`,
  )
  return data
}
